import httpClient from './httpClient';

const conditionActivationService = {
    getCondition(params) {
        const { email, pkAgency } = params;
        if (pkAgency) {
            return httpClient.get(`/api/remote-controlled/activation?email=${email}&pkAgency=${pkAgency}`);
        } else {
            return httpClient.get(`/api/remote-controlled/activation?email=${email}`);
        }
    }
}

export default conditionActivationService;
